export default __webpack_public_path__ + "fonts/CiscoSansThin-webfont.eot";